module.exports = __webpack_public_path__ + "media/images/admin/auth-bg-d1af4bdbd5820a8e3e9b0c0fedfdc612.jpg";